import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OrganisationConnectorService } from '../../con-x/saas-service-management/organisation-connector.service';
@Injectable({providedIn: 'root'})
export class DataspacePackageGuard implements CanActivate {
  constructor(private service: OrganisationConnectorService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot) {
    const id = [...route.pathFromRoot].reverse().map(r => Number(r.paramMap.get('organisationId'))).find(id => id > 0);
    const redirect = this.router.createUrlTree(id ? ['/organisations', id, 'construct-x-settings'] : ['/marktplatz']);
    return id ? this.service.get(id).pipe(map(assignment => assignment?.walletReady ? true : redirect), catchError(() => of(redirect))) : redirect;
  }
}
